import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRadPreFaturaBloqueioPlacaRelatorio({
  payload,
}) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'radprefaturabloqueioplacarelatorio', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRadPreFaturaBloqueioPlacaRelatorio({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(api.delete, `radprefaturabloqueioplacarelatorio/${fatu_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoradprefaturabloqueioplacarelatorio, params } = payload;

    yield call(
      api.post,
      'radprefaturabloqueioplacarelatorio',
      operacaoradprefaturabloqueioplacarelatorio
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/radprefaturabloqueioplacarelatorio');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `radprefaturabloqueioplacarelatorio/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoradprefaturabloqueioplacarelatorio, params } = payload;

    yield call(
      api.put,
      'radprefaturabloqueioplacarelatorio',
      operacaoradprefaturabloqueioplacarelatorio
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/radprefaturabloqueioplacarelatorio');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'radprefaturabloqueioplacarelatorio', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/OPERACAORADPREFATURABLOQUEIOPLACARELATORIO_IN_REQUEST',
    requestOperacaoRadPreFaturaBloqueioPlacaRelatorio
  ),
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/DELETE_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    deleteOperacaoRadPreFaturaBloqueioPlacaRelatorio
  ),
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/SUCCESS_REMOVE',
    requestOperacaoRadPreFaturaBloqueioPlacaRelatorio
  ),
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/STORE_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    store
  ),
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/FIND_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    find
  ),
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/UPDATE_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    update
  ),
  takeLatest(
    '@operacaoradprefaturabloqueioplacarelatorio/RECORD_FILTERING',
    applyedFilters
  ),
]);
